import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { MessageSquare } from 'lucide-react';
import { DialogueSection } from '../../types/dialogue';

interface DialogueNodeProps {
  data: {
    label: string;
    dialogueKey: string;
    section: DialogueSection;
  };
  selected: boolean;
}

export const DialogueNode: React.FC<DialogueNodeProps> = ({ data, selected }) => {
  return (
    <div 
      className={`px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 dark:from-blue-700 dark:to-blue-800 text-white rounded-lg min-w-[200px] shadow-lg transition-all duration-200 hover:shadow-xl hover:scale-105 cursor-pointer ${
        selected ? 'ring-2 ring-blue-400 ring-offset-2 ring-offset-gray-100 dark:ring-offset-gray-800 scale-105' : ''
      }`}
    >
      <Handle 
        type="target" 
        position={Position.Left} 
        className="w-3 h-3 bg-blue-400 border-2 border-white dark:border-gray-800"
      />
      <div className="flex items-center gap-2 mb-2">
        <MessageSquare size={18} className="text-blue-200" />
        <span className="font-semibold text-sm">{data.label}</span>
      </div>
      <div className="space-y-1">
        <div className="text-xs text-blue-100 flex items-center gap-2">
          <span className="font-medium">Triggers:</span>
          <span className="bg-blue-500/30 px-2 py-0.5 rounded-full">{data.section.triggers.length}</span>
        </div>
        <div className="text-xs text-blue-100 flex items-center gap-2">
          <span className="font-medium">Conditions:</span>
          <span className="bg-blue-500/30 px-2 py-0.5 rounded-full">{data.section.conditions.length}</span>
        </div>
      </div>
      <Handle 
        type="source" 
        position={Position.Right} 
        className="w-3 h-3 bg-blue-400 border-2 border-white dark:border-gray-800"
      />
    </div>
  );
};